import React from 'react'

export default function P302Info({data}) {
    const render = () =>{

        return data && data.length >0 &&data.map((item,index)=>{
            if(item.contractDetailLeft && item.contractDetailRight){
                return (
                        <React.Fragment key={"hd"+index}>
                        <div className="p-col-12 p-md-6">
                            <div key={"left_"+index} >{item.contractDetailLeft}</div>
                        </div>
                        <div className="p-col-12 p-md-6 " >
                            <div key={"right_"+index} >{item.contractDetailRight}</div>
                        </div>
                        {/* <div className="p-col-12 p-md-12 line-responsive" style={{marginTop:-20,marginBottom:-10}} ><hr/></div> */}
                    </React.Fragment>
                )
            }

        })
    }
  
    return (
        <>
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-12">
                    <h4 className="p-no-box line-under"><b>รายละเอียดสัญญา</b></h4>
                </div>
            </div>
            <div className="p-grid  p-fluid"  style={{marginLeft:20}}>
                {render()}
            </div>        
        </>
    )
}
